import { Component, Input, inject } from '@angular/core';
import { AgreementMetaDataConstants } from '../../../pages/agreement-metadata-generation.helper';
import { MetadataHighlightsService } from '../../../pages/metadata-highlights.service';

@Component({
    selector: 'app-pdf-reference-icon',
    templateUrl: './pdf-reference-icon.component.html',
    styleUrl: './pdf-reference-icon.component.scss'
})
export class PdfReferenceIconComponent {
    @Input({ required: true }) public fieldName: AgreementMetaDataConstants;

    private readonly highlightsService = inject(MetadataHighlightsService);

    public get hasTextReference(): boolean {
        return this.highlightsService.hasEnumFieldTextReference(this.fieldName);
    }

    public get sourceText(): string {
        const reference = this.highlightsService.getEnumFieldTextReference(this.fieldName);
        return reference?.text || '';
    }

    public onClick(): void {
        this.highlightsService.notifyFieldFocused(this.fieldName);
    }
}
